export enum StaticCategories {
    All = 'all',
    None = 'uncategorized',
}
